// src/services/FetchRosterAllocation.js

import { baseUrl_SPB } from "../BaseUrl";

const FetchRosterAllocationService = async (token) => {
  try {
    const response = await fetch(`${baseUrl_SPB}/api/v1/rostertimeallocation/getusertimeallocations`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch roster data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching roster:', error);
    return null;
  }
};

export default FetchRosterAllocationService;
